// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3ixu-","modal-title":"Modal_modal-title__1XtGw","modal-body":"Modal_modal-body__2UaTH","modal-button":"Modal_modal-button__2EaxE"};